import { render, staticRenderFns } from "./BatDialog.vue?vue&type=template&id=a7361118"
import script from "./BatDialog.vue?vue&type=script&lang=js"
export * from "./BatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports